module.exports = __webpack_public_path__ + "static/img/banner004.d824189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner004.png
// module id = 4g9L
// module chunks = 15